import Box from '@mui/material/Box';

// project imports
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  return (
    <>
      <Search />
      <Notification />
      <Profile />
    </>
  );
}
